import { handleActions } from 'redux-actions';
import {
  setAssignOrganizationId,
  setAssignProduct,
  setAssignTenantId,
  setAssignCohortId,
  setAssignOrgTypeId,
} from './actions';
import { CADS_AI_PRODUCTS } from '@/shared/helpers/constants';

const defaultState = {
  assignedProduct: CADS_AI_PRODUCTS.LEARNING_PATH,
  assignedOrgId: null,
  assignedOrgTypeId: null,
  tenantId: null,
  assignedCohortId: null,
};

export default handleActions(
  {
    [setAssignProduct](state, { payload }) {
      return {
        ...state,
        assignedProduct: payload,
      };
    },
    [setAssignOrganizationId](state, { payload }) {
      return {
        ...state,
        assignedOrgId: payload,
      };
    },
    [setAssignOrgTypeId](state, { payload }) {
      return {
        ...state,
        assignedOrgTypeId: payload,
      };
    },
    [setAssignCohortId](state, { payload }) {
      return {
        ...state,
        assignedCohortId: payload,
      };
    },
    [setAssignTenantId](state, { payload }) {
      return {
        ...state,
        tenantId: payload,
      };
    },
  },
  defaultState,
);
